<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2025-09-03 17:20:53
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2025-10-17 15:23:58
 * @FilePath: \vue-app-console\src\views\Firmware\SearchForm.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="search_form">
        <a-input v-model:value="formData.tenant_name" allowClear :placeholder="t('tenant.tenant_name')" style="width: 150px; margin: 0 10px 5px 0" @change="handleInputChange('tenant_name')" @pressEnter="handlePressEnter" />
        <a-input v-model:value="formData.tenant_code" allowClear :placeholder="t('tenant.tenant_code')" style="width: 150px; margin: 0 10px 5px 0" @change="handleInputChange('tenant_code')" @pressEnter="handlePressEnter" />
        <a-input v-model:value="formData.app_id" allowClear :placeholder="t('tenant.app_id')" style="width: 150px; margin: 0 10px 5px 0" @change="handleInputChange('app_id')" @pressEnter="handlePressEnter" />
        <a-input v-model:value="formData.project_no" allowClear :placeholder="t('tenant.project_no')" style="width: 150px; margin: 0 10px 5px 0" @change="handleInputChange('project_no')" @pressEnter="handlePressEnter" />
        
        <a-button type="primary" size="small" style="margin-right:10px" @click="handleSearch">
            <img src="@/assets/image/search.png" alt="" width="15" style="margin-right: 5px;margin-top:-3px">
            {{ $t('base.search') }}
        </a-button>
    </div>
</template>

<script setup>
    import { ref, reactive, onMounted } from "vue";
    import { LoginApi } from '@/api/LoginApi.js';
    import { AdvancedFunApi } from '@/api/AdvancedFunApi.js';
    import { useI18n } from 'vue-i18n';
    const { t } = useI18n()
    
    const emits = defineEmits([
        'handleInputChange',
        'handleSearch',
        'handleSelectChange',
    ])

    const userInfo = ref(JSON.parse(sessionStorage.getItem('userInfo')))
    const formData = reactive({
        tenant_name: '',
        tenant_code: '',
        app_id: '',
        project_no: '',
    })

    const handleInputChange = (key) => {
        console.log(key, 'input key')
        emits('handleInputChange',formData)
    }
    
    const handlePressEnter = () => {
        console.log(formData,'formData')
        emits('handlePressEnter',formData)
    }

    const handleSearch = () => {
        console.log(formData,'formData')
        emits('handleSearch',formData)
    }
    
    defineExpose({
        formData
    })

    onMounted(()=>{

    })

</script>

<style lang="scss" scoped>
.search_form{
    margin: 30px 0 15px;
}
</style>